import { LinearChartSelection } from "@ctypes";
import { useDynamicChartWidth } from "@hooks";
import { constants } from "@layout";
import { PropsWithChildren, useState } from "react";
import { PerformanceChartContext } from "./context";
import { PerformanceChartProviderProps } from "./types";

export const PerformanceChartProvider = ({
  strokeWidth = constants.chart.performance.strokeWidth,
  data,
  children,
}: PropsWithChildren<PerformanceChartProviderProps>) => {
  const defaultIndex = ((): LinearChartSelection => {
    if (data.fiveYear.valid) {
      return "fiveYear";
    }
    if (data.oneYear.valid) {
      return "oneYear";
    }
    if (data.sixMonth.valid) {
      return "sixMonth";
    }
    if (data.oneMonth.valid) {
      return "oneMonth";
    }
    if (data.oneWeek.valid) {
      return "oneWeek";
    }
    return "oneDay";
  })();

  const [selectedTimeRange, setSelectedTimeRange] = useState<LinearChartSelection>(defaultIndex);

  const { width } = useDynamicChartWidth();

  const selectedChart = data[selectedTimeRange];

  const { path, height } = selectedChart;

  const props = {
    value: {
      width,
      height,
      strokeWidth,
      path,
      selectedTimeRange,
      setSelectedTimeRange,
      selectedChart,
      data,
    },
  };

  return <PerformanceChartContext.Provider {...props}>{children}</PerformanceChartContext.Provider>;
};
